
export { default as Badge } from "./components/icon-elements/Badge/Badge.js"